import { Box } from "@mui/system"
import BrandsDateFilter from "./BrandsContent/BrandsDateFilter"
import BrandsSearchFilter from "./BrandsContent/BrandsSearchFilter"
import BrandsSearchItems from "./BrandsContent/BrandsSearchItems"


const Brands = () => {
  return (
    <>
       <Box sx={{ px: 2 }}>
          <BrandsDateFilter/>
          <BrandsSearchFilter/>
          <BrandsSearchItems/>
      </Box>
    </>
  )
}

export default Brands